type keyVal = { [key: string]: string }

export const MONTHS: keyVal = {
  jan: 'Janvier',
  feb: 'Février',
  mar: 'Mars',
  apr: 'Avril',
  may: 'Mai',
  jun: 'Juin',
  jul: 'Juillet',
  aug: 'Août',
  sep: 'Septembre',
  oct: 'Octobre',
  nov: 'Novembre',
  dec: 'Décembre'
}

export const DAYS: keyVal = {
  mon: 'Lundi',
  tue: 'Mardi',
  wed: 'Mercredi',
  thu: 'Jeudi',
  fri: 'Vendredi',
  sat: 'Samedi',
  sun: 'Dimanche',
}

export const MONTH_NAMES: string[] = Object.keys(MONTHS).map(month => MONTHS[month])
export const DAY_NAMES: string[] = Object.keys(DAYS).map(day => DAYS[day].slice(0, 2))
